import React from 'react';
import './Clientes-Modal.css'; // Asegúrate de que este CSS contenga los estilos mejorados
//import inversor from './assets/Humilladero/inversor.jpeg';
import Video from './assets/CoomultrupOficinas/Video.mp4';

const CoomultrupOficinas = () => {
  return (
    <div>
      <div className="container">
        <h2>
        ✅ Proyecto: Oficinas Coomultrup🌞✨{' '}
         
        </h2>
        <p>
         
          <video controls>
            <source src={Video} type="video/mp4" />
            Tu navegador no soporta la reproducción de video.
          </video>
         

        

   <span className="highlight">
            {' '}
          Energía solar para potenciar el rendimiento empresarial: eficiencia, ahorro y sostenibilidad en cada operación.
          </span>


<br/><br/>En las oficinas administrativas de Coomultrup instalamos un sistema solar fotovoltaico conectado a la red con una capacidad de 11.36 kWp, conformado por  16 paneles solares de alta eficiencia y un inversor multicadena de 15 kW, una tecnología robusta diseñada para optimizar el flujo energético y garantizar estabilidad en entornos con alta demanda operativa.

<br/><br/>Gracias a esta solución, el sistema gestiona de manera confiable las cargas eléctricas del edificio <span className="highlight">iluminación, equipos de oficina, sistemas informáticos y dispositivos de uso continuo</span> asegurando eficiencia energética durante toda la jornada laboral y reduciendo el consumo tomado de la red.

<br/><br/>Los objetivos de este proyecto fueron:

<br/><br/>✔ Reducir los costos asociados al consumo eléctrico de la entidad
<br/>✔ Incorporar una solución sostenible que aporte al compromiso ambiental institucional
<br/>✔ Garantizar energía constante para las actividades administrativas y operativas de las oficinas

<br/><br/>Hoy, las oficinas de Coomultrup generan una parte importante de su energía limpia, logrando ahorros significativos en la factura mensual y permitiendo que estos recursos se redirijan a fortalecer procesos institucionales y bienestar de sus asociados.

<br/><br/>Esta instalación convierte a Coomultrup en un referente de innovación energética y compromiso ambiental, demostrando que la sostenibilidad también es una estrategia empresarial inteligente y rentable.

<br/><br/>Este proyecto cuenta con el acompañamiento de <span className="highlight">IPSUM Ingeniería e Innovación</span>, ofreciendo:

<br/><br/>🔧 Soporte técnico y mantenimiento preventivo
<br/>🔧 Monitoreo del sistema para garantizar máxima eficiencia energética
<br/>🔧 Instalación estructural segura, diseñada para prolongar la vida útil del sistema y facilitar su mantenimiento.
<br/>🔧 Capacitación al usuario en el manejo de la aplicación de monitoreo
<br/>🔧 Acompañamiento presencial de nuestros ingenieros durante y después de la instalación

<br/><br/><span className="highlight">Una decisión inteligente que une sostenibilidad, optimización de recursos y fortalecimiento empresarial.</span>

        </p>
      </div>
    </div>
  );
};

export default CoomultrupOficinas;
